import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManageorderComponent } from './manageorder.component';

const routes: Routes = [
    {
        path: '',
        component: ManageorderComponent,
        data: {
            title: 'Manage Order'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ManageorderRoutingModule { }
